module.exports = __webpack_public_path__ + "static/img/4-3.fd5a6ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/4-3.png
// module id = 7NWz
// module chunks = 0